// State / province / territory lists for the countries this product serves
// (United States, Canada, Mexico). Values are the standard postal/ISO codes that
// get stored; names are shown to the user. Countries not listed here fall back to
// a free-text entry. Mirrors the mobile app's StateProvinceData.

const data = {
    'United States': [
        {name: 'Alabama', code: 'AL'}, {name: 'Alaska', code: 'AK'}, {name: 'Arizona', code: 'AZ'},
        {name: 'Arkansas', code: 'AR'}, {name: 'California', code: 'CA'}, {name: 'Colorado', code: 'CO'},
        {name: 'Connecticut', code: 'CT'}, {name: 'Delaware', code: 'DE'}, {name: 'District of Columbia', code: 'DC'},
        {name: 'Florida', code: 'FL'}, {name: 'Georgia', code: 'GA'}, {name: 'Hawaii', code: 'HI'},
        {name: 'Idaho', code: 'ID'}, {name: 'Illinois', code: 'IL'}, {name: 'Indiana', code: 'IN'},
        {name: 'Iowa', code: 'IA'}, {name: 'Kansas', code: 'KS'}, {name: 'Kentucky', code: 'KY'},
        {name: 'Louisiana', code: 'LA'}, {name: 'Maine', code: 'ME'}, {name: 'Maryland', code: 'MD'},
        {name: 'Massachusetts', code: 'MA'}, {name: 'Michigan', code: 'MI'}, {name: 'Minnesota', code: 'MN'},
        {name: 'Mississippi', code: 'MS'}, {name: 'Missouri', code: 'MO'}, {name: 'Montana', code: 'MT'},
        {name: 'Nebraska', code: 'NE'}, {name: 'Nevada', code: 'NV'}, {name: 'New Hampshire', code: 'NH'},
        {name: 'New Jersey', code: 'NJ'}, {name: 'New Mexico', code: 'NM'}, {name: 'New York', code: 'NY'},
        {name: 'North Carolina', code: 'NC'}, {name: 'North Dakota', code: 'ND'}, {name: 'Ohio', code: 'OH'},
        {name: 'Oklahoma', code: 'OK'}, {name: 'Oregon', code: 'OR'}, {name: 'Pennsylvania', code: 'PA'},
        {name: 'Rhode Island', code: 'RI'}, {name: 'South Carolina', code: 'SC'}, {name: 'South Dakota', code: 'SD'},
        {name: 'Tennessee', code: 'TN'}, {name: 'Texas', code: 'TX'}, {name: 'Utah', code: 'UT'},
        {name: 'Vermont', code: 'VT'}, {name: 'Virginia', code: 'VA'}, {name: 'Washington', code: 'WA'},
        {name: 'West Virginia', code: 'WV'}, {name: 'Wisconsin', code: 'WI'}, {name: 'Wyoming', code: 'WY'},
    ],
    'Canada': [
        {name: 'Alberta', code: 'AB'}, {name: 'British Columbia', code: 'BC'}, {name: 'Manitoba', code: 'MB'},
        {name: 'New Brunswick', code: 'NB'}, {name: 'Newfoundland and Labrador', code: 'NL'},
        {name: 'Northwest Territories', code: 'NT'}, {name: 'Nova Scotia', code: 'NS'}, {name: 'Nunavut', code: 'NU'},
        {name: 'Ontario', code: 'ON'}, {name: 'Prince Edward Island', code: 'PE'}, {name: 'Quebec', code: 'QC'},
        {name: 'Saskatchewan', code: 'SK'}, {name: 'Yukon', code: 'YT'},
    ],
    'Mexico': [
        {name: 'Aguascalientes', code: 'AGU'}, {name: 'Baja California', code: 'BCN'},
        {name: 'Baja California Sur', code: 'BCS'}, {name: 'Campeche', code: 'CAM'}, {name: 'Chiapas', code: 'CHP'},
        {name: 'Chihuahua', code: 'CHH'}, {name: 'Ciudad de Mexico', code: 'CMX'}, {name: 'Coahuila', code: 'COA'},
        {name: 'Colima', code: 'COL'}, {name: 'Durango', code: 'DUR'}, {name: 'Guanajuato', code: 'GUA'},
        {name: 'Guerrero', code: 'GRO'}, {name: 'Hidalgo', code: 'HID'}, {name: 'Jalisco', code: 'JAL'},
        {name: 'Mexico (State)', code: 'MEX'}, {name: 'Michoacan', code: 'MIC'}, {name: 'Morelos', code: 'MOR'},
        {name: 'Nayarit', code: 'NAY'}, {name: 'Nuevo Leon', code: 'NLE'}, {name: 'Oaxaca', code: 'OAX'},
        {name: 'Puebla', code: 'PUE'}, {name: 'Queretaro', code: 'QUE'}, {name: 'Quintana Roo', code: 'ROO'},
        {name: 'San Luis Potosi', code: 'SLP'}, {name: 'Sinaloa', code: 'SIN'}, {name: 'Sonora', code: 'SON'},
        {name: 'Tabasco', code: 'TAB'}, {name: 'Tamaulipas', code: 'TAM'}, {name: 'Tlaxcala', code: 'TLA'},
        {name: 'Veracruz', code: 'VER'}, {name: 'Yucatan', code: 'YUC'}, {name: 'Zacatecas', code: 'ZAC'},
    ],
}

// True if the country has a bundled subdivision list (otherwise use free text).
export function hasStates(country) {
    return Object.prototype.hasOwnProperty.call(data, country)
}

// v-autocomplete items ([{title, value}]) for the country, or [] when none.
export function statesFor(country) {
    return (data[country] || []).map(s => ({title: `${s.name} (${s.code})`, value: s.code}))
}

// Friendly name for a stored code within a country, or the code itself if unknown.
export function stateNameForCode(country, code) {
    if (!code) return ''
    const match = (data[country] || []).find(s => s.code === code)
    return match ? match.name : code
}
